export const OtelOp = {
    RENDER_IFRAME_LIFECYCLE: {
        name: 'custom_chart_iframe_lifecycle',
        description: 'Full iframe lifecycle from init start to render complete',
    },
    NETWORK_POSTMESSAGE_INIT: {
        name: 'custom_chart_postmessage_init',
        description: 'TSToChartEvent.Initialize postMessage dispatch to iframe',
    },
    NETWORK_DATA_FETCH: {
        name: 'custom_chart_data_fetch',
        description: 'Full data fetch cycle from query dispatch to data received',
    },
    NETWORK_POSTMESSAGE_QUERY: {
        name: 'custom_chart_postmessage_query',
        description: 'GetDataQuery postMessage round-trip to retrieve query definitions',
    },
};
//# sourceMappingURL=otel-operations.js.map